"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 防抖函数
 * @param {T} fn
 * @param {number} delay
 * @return
 */
function debounce(fn, delay) {
  var timer = null;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    timer = setTimeout(function () {
      typeof fn === "function" && fn.apply(null, args);
      clearTimeout(timer);
    }, delay > 0 ? delay : 100);
  };
}
var _default2 = exports.default = {
  name: "VScaleScreen",
  props: {
    width: {
      type: [String, Number],
      default: 1920
    },
    height: {
      type: [String, Number],
      default: 1080
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    autoScale: {
      type: [Object, Boolean],
      default: true
    },
    selfAdaption: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 500
    },
    boxStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    wrapperStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      currentWidth: 0,
      currentHeight: 0,
      originalWidth: 0,
      originalHeight: 0,
      onResize: null,
      observer: null
    };
  },
  watch: {
    selfAdaption: function selfAdaption(val) {
      if (val) {
        this.resize();
        this.addListener();
      } else {
        this.clearListener();
        this.clearStyle();
      }
    }
  },
  computed: {
    screenWrapper: function screenWrapper() {
      return this.$refs["screenWrapper"];
    }
  },
  methods: {
    initSize: function initSize() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        // console.log("初始化样式");
        //给父元素设置 overflow:hidden
        _this.screenWrapper.parentNode.style.overflow = "hidden";
        _this.screenWrapper.parentNode.scrollLeft = 0;
        _this.screenWrapper.parentNode.scrollTop = 0;
        _this.$nextTick(function () {
          // region 获取大屏真实尺寸
          if (_this.width && _this.height) {
            _this.currentWidth = _this.width;
            _this.currentHeight = _this.height;
          } else {
            _this.currentWidth = _this.screenWrapper.clientWidth;
            _this.currentHeight = _this.screenWrapper.clientHeight;
          }
          // endregion
          // region 获取画布尺寸
          if (!_this.originalHeight || !_this.originalWidth) {
            _this.originalWidth = window.screen.width;
            _this.originalHeight = window.screen.height;
          }
          // endregion
          resolve();
        });
      });
    },
    updateSize: function updateSize() {
      if (this.currentWidth && this.currentHeight) {
        this.screenWrapper.style.width = "".concat(this.currentWidth, "px");
        this.screenWrapper.style.height = "".concat(this.currentHeight, "px");
      } else {
        this.screenWrapper.style.width = "".concat(this.originalWidth, "px");
        this.screenWrapper.style.height = "".concat(this.originalHeight, "px");
      }
    },
    handleAutoScale: function handleAutoScale(scale) {
      if (!this.autoScale) return;
      var screenWrapper = this.screenWrapper;
      var domWidth = screenWrapper.clientWidth;
      var domHeight = screenWrapper.clientHeight;
      var currentWidth = document.body.clientWidth;
      var currentHeight = document.body.clientHeight;
      screenWrapper.style.transform = "scale(".concat(scale, ",").concat(scale, ") ");
      var mx = Math.max((currentWidth - domWidth * scale) / 2, 0);
      var my = Math.max((currentHeight - domHeight * scale) / 2, 0);
      if ((0, _typeof2.default)(this.autoScale) === "object") {
        // @ts-ignore
        !this.autoScale.x && (mx = 0);
        // @ts-ignore
        !this.autoScale.y && (my = 0);
      }
      // console.log({
      //   mx,
      //   my,
      //   currentWidth,
      //   currentHeight,
      //   domWidth,
      //   domHeight,
      //   scale,
      // });
      this.screenWrapper.style.margin = "".concat(my, "px ").concat(mx, "px");
    },
    updateScale: function updateScale() {
      var screenWrapper = this.screenWrapper;
      // 获取真实视口尺寸
      var currentWidth = document.body.clientWidth;
      var currentHeight = document.body.clientHeight;
      // 获取大屏最终的宽高onResize
      var realWidth = this.currentWidth || this.originalWidth;
      var realHeight = this.currentHeight || this.originalHeight;
      // 计算缩放比例
      var widthScale = currentWidth / realWidth;
      var heightScale = currentHeight / realHeight;
      // console.log({currentWidth, currentHeight,realWidth,realHeight});

      // 若要铺满全屏，则按照各自比例缩放
      if (this.fullScreen) {
        screenWrapper.style.transform = "scale(".concat(widthScale, ",").concat(heightScale, ")");
        return false;
      }
      // 按照宽高最小比例进行缩放
      var scale = Math.min(widthScale, heightScale);
      this.handleAutoScale(scale);
    },
    initMutationObserver: function initMutationObserver() {
      var _this2 = this;
      var screenWrapper = this.screenWrapper;
      var observer = this.observer = new MutationObserver(function () {
        _this2.onResize();
      });
      observer.observe(screenWrapper, {
        attributes: true,
        attributeFilter: ["style"],
        attributeOldValue: true
      });
    },
    clearListener: function clearListener() {
      window.removeEventListener("resize", this.onResize);
    },
    addListener: function addListener() {
      window.addEventListener("resize", this.onResize);
    },
    clearStyle: function clearStyle() {
      // console.log("清除");
      var screenWrapper = this.screenWrapper;
      screenWrapper.parentNode.style.overflow = "auto";
      screenWrapper.style = "";
    },
    resize: function () {
      var _resize = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.selfAdaption) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.next = 2;
              return this.initSize();
            case 2:
              this.updateSize();
              this.updateScale();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function resize() {
        return _resize.apply(this, arguments);
      }
      return resize;
    }()
  },
  mounted: function mounted() {
    var _this3 = this;
    this.onResize = debounce(function () {
      _this3.resize();
    }, this.delay);
    this.$nextTick(function () {
      if (_this3.selfAdaption) {
        _this3.resize();
        _this3.addListener();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.clearListener();
    // this.observer.disconnect()
  }
}; //